
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import Text from './Text';
import { getActions as authGetActions } from '../sagas/auth';

const LoginMessage = (props) => {
    const classNames = mergeStyleSets({
        root: {
            paddingTop: '8px',
            paddingBottom: '8px'
        }
    });
    return (
        <div className={classNames.root}><Text>{props.text || '\u00A0'}</Text></div>
    );
}

const LoginInfo = (props) => {
    let text = null
    if (props.loginFailed) {
        switch (props.loginError) {
            case '"ACCOUNT_IS_BLOCKED"':
                text = 'Uživatelský účet je zablokován';
                break;
            case '"EMAIL_OR_PASSWORD_IS_INVALID"':
                text = 'Neplatné uživatelské jméno nebo heslo';
                break;
            default:
                text = 'Nelze se přihlásit';
                break;
        }
    }
    if (props.loading) {
        text = 'Probíhá přihlašování...';
    }
    return (
        <LoginMessage
            text={text}
        />
    );
}

const LoginForm = (props) => {

    const dispatch = useDispatch();
    const authActions = authGetActions(dispatch);

    const auth = useSelector(state => {
        return state.auth;
    });

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const classNames = mergeStyleSets({
        root: {
            backgroundColor: '#eeeeee',
            width: '400px',
            padding: '16px'
        }
    });

    const handleOnClick = (event) => {
        authActions.login(username, password);
    }

    const handleOnChangePassword = (event) => {
        setPassword(event.target.value);
    }

    const handleOnChangeUserName = (event) => {
        setUsername(event.target.value);
    }

    const handleOnKeyDown = (event) => {
        if (event.keyCode === 13) {
            authActions.login(username, password);
        }
    }

    const getClassName = (name) => {
        return props.styles
            ? props.styles[name]
            : classNames[name];
    }

    return (
        <div className={getClassName('root')}>
            <TextField
                label="Uživatelské jméno"
                disabled={auth.loading}
                onChange={handleOnChangeUserName}
                onKeyDown={handleOnKeyDown}
            />
            <TextField
                label="Heslo"
                type="password"
                disabled={auth.loading}
                onChange={handleOnChangePassword}
                onKeyDown={handleOnKeyDown}
            />
            <LoginInfo
                loginFailed={auth.loginFailed}
                loginError={auth.loginError?.body}
                loading={auth.loading}
            />
            <PrimaryButton
                text="Přihlásit"
                disabled={auth.loading}
                onClick={handleOnClick}
            />
        </div>
    );
}

export default LoginForm;
